"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListBucketAnalyticsConfigurationsInput_1 = require("./ListBucketAnalyticsConfigurationsInput");
var ListBucketAnalyticsConfigurationsOutput_1 = require("./ListBucketAnalyticsConfigurationsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.ListBucketAnalyticsConfigurations = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "ListBucketAnalyticsConfigurations",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?analytics"
    },
    input: {
        shape: ListBucketAnalyticsConfigurationsInput_1.ListBucketAnalyticsConfigurationsInput
    },
    output: {
        shape: ListBucketAnalyticsConfigurationsOutput_1.ListBucketAnalyticsConfigurationsOutput
    },
    errors: []
};
//# sourceMappingURL=ListBucketAnalyticsConfigurations.js.map